import { Icon } from '@iconify/react';
import { Colors, Fonts } from '../../../config/theme';
import FormControl from '../../../components/form_control';
import UtilitiesRepository from '../../../data/repositories/utilities_repository';
import { Row } from 'antd';
import { useState } from 'react';
import { Accordion, AccordionItem, Button } from '@nextui-org/react';
import { FaCheck } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';

export function AttributeNameField({
  hintTextEn,
  hintTextAr,
  data,
  setData,
}: {
  data: any;
  setData: any;
  hintTextEn: string;
  hintTextAr: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0px !important',
      }}
    >
      <div>
        <h5 style={{ color: '#00273380', fontSize: '16px' }}>
          Field name (ENGLISH)
        </h5>
        <div className="col-lg-12 col-md-12 col-sm-12  p-2">
          <FormControl
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setData({ ...data, name_en: e.target.value })
            }
            input={true}
            value={data.name_en}
            placeholder={hintTextEn}
          />
        </div>
      </div>
      <TranslateButton
        leftToRightCallback={async () => {
          const text = await UtilitiesRepository.translateText(data.name_en);
          setData({ ...data, name_ar: text });
        }}
        rightToLeftCallback={async () => {
          const text = await UtilitiesRepository.translateText(
            data.name_ar,
            true,
          );
          setData({ ...data, name_en: text });
        }}
      />
      <div style={{ marginLeft: '5px' }}>
        <h5 style={{ color: '#00273380', fontSize: '16px' }}>
          Field name (عربي)
        </h5>
        <div className="col-lg-12 col-md-12 col-sm-12  p-2">
          <FormControl
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setData({ ...data, name_ar: e.target.value })
            }
            input={true}
            value={data.name_ar}
            placeholder={hintTextAr}
            style={{
              direction: 'rtl',
            }}
          />
        </div>
      </div>
    </div>
  );
}
export function TranslateButton({
  leftToRightCallback,
  rightToLeftCallback,
  style,
}: {
  leftToRightCallback: () => void;
  rightToLeftCallback: () => void;
  style?: React.CSSProperties;
}) {
  return (
    <div
      style={
        style !== undefined
          ? style
          : {
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: Colors.greenSecondary,
              borderRadius: '5px',
              padding: '5px',
              margin: '0px 10px',
              alignSelf: 'center',
              maxWidth: '40px',
            }
      }
    >
      <Icon
        icon="ant-design:arrow-left"
        color={Colors.greenMain}
        onClick={rightToLeftCallback}
        style={{
          alignSelf: 'center',
          width: '20px',
          height: '20px',
          cursor: 'pointer',
        }}
      />
      <Icon
        icon="mdi:translate"
        color={Colors.greenMain}
        style={{
          width: '20px',
          height: '20px',
          alignSelf: 'center',
        }}
      />
      <Icon
        icon="ant-design:arrow-right"
        color={Colors.greenMain}
        onClick={leftToRightCallback}
        style={{
          alignSelf: 'center',
          width: '20px',
          height: '20px',
          cursor: 'pointer',
        }}
      />
    </div>
  );
}

export function OneLanguageTranslateButton({
  onClick,
  translatingArabicToEnglish = false,
}: {
  onClick: () => void;
  translatingArabicToEnglish?: boolean;
}) {
  return (
    <Button
      startContent={<span>{translatingArabicToEnglish ? 'ع' : 'En'}</span>}
      endContent={<span>{translatingArabicToEnglish ? 'En' : 'ع'}</span>}
      color="success"
      variant="light"
      onClick={onClick}
    >
      <Icon
        icon="ant-design:arrow-right"
        color={Colors.greenMain}
        style={{
          alignSelf: 'center',
          cursor: 'pointer',
        }}
      />
    </Button>
  );
}

export const HelpBox = ({
  description = 'Click here to view guidelines & examples',
  guidelines,
  initiallyOpen = true,
  correctExamples,
  incorrectExamples,
  locale = 'en',
}: {
  description?: React.ReactNode;
  initiallyOpen?: boolean;
  guidelines: string[];
  correctExamples: string[];
  incorrectExamples: string[];
  locale?: string;
}) => {
  // Determine the maximum number of rows to align the columns

  const [selectedKeys, setSelectedKeys] = useState<Set<string>>(
    initiallyOpen ? new Set(['1']) : new Set(),
  );
  const maxRows = Math.max(
    guidelines.length,
    correctExamples.length,
    incorrectExamples.length,
  );

  const itemClasses = {
    base: 'py-0 w-full pb-2 min-w-full m-0 px-0',
    title: 'font-normal text-small p-0 m-0',
    trigger: 'px-0 py-0  rounded-lg h-14 flex items-center',
    indicator: 'text-medium',
    content: 'text-small px-0',
  };

  const colorPrimary = 'orange';

  return (
    <Accordion
      variant="light"
      isCompact
      itemClasses={itemClasses}
      selectedKeys={selectedKeys}
      onSelectionChange={(keys) => {
        setSelectedKeys(keys as Set<string>);
      }}
      style={{
        width: '100%',
      }}
    >
      <AccordionItem key="1" aria-label="Accordion 1" title={description}>
        <div
          style={{
            border: `1px solid ${Colors.greenMain}`,
            borderRadius: '8px',
            padding: '12px',
            backgroundColor: '#f9f9f9',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            width: '100%',
          }}
        >
          <div>
            {/* Headers */}
            <Row justify="space-between" style={{ marginBottom: '0px' }}>
              <p
                style={{
                  fontWeight: 'bold',
                  color: colorPrimary,
                  width: '30%',
                }}
              >
                Guidelines
              </p>{' '}
              {incorrectExamples.length > 0 && (
                <p
                  style={{
                    fontWeight: 'bold',
                    color: 'red',
                    width: '30%',
                  }}
                >
                  Incorrect Examples
                </p>
              )}
              {correctExamples.length > 0 && (
                <p
                  style={{
                    fontWeight: 'bold',
                    color: 'green',
                    width: '30%',
                  }}
                >
                  Correct Examples
                </p>
              )}
            </Row>

            {/* Content Rows */}
            {Array.from({ length: maxRows }, (_, index) => (
              <Row
                justify="space-between"
                key={index}
                style={{ marginBottom: '8px' }}
              >
                {/* Guidelines Column */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    // if both correct and incorrect examples are empty, take 100% of the width, else take 30% for each
                    width: `${
                      incorrectExamples.length === 0 &&
                      correctExamples.length === 0
                        ? '100%'
                        : incorrectExamples.length === 0 ||
                            correctExamples.length === 0
                          ? '60%'
                          : '30%'
                    }`,
                  }}
                >
                  {guidelines[index] ? (
                    <>
                      <span
                        style={{
                          height: '8px',
                          width: '8px',
                          backgroundColor: colorPrimary,
                          borderRadius: '50%',
                          marginRight: '10px',
                        }}
                      ></span>
                      <span
                        style={{
                          color: Colors.primaryText,
                        }}
                      >
                        {guidelines[index]}
                      </span>
                    </>
                  ) : (
                    <span>&nbsp;</span> // Empty space for alignment
                  )}
                </div>

                {/* Incorrect Examples Column */}
                {incorrectExamples.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '30%',
                    }}
                  >
                    {incorrectExamples[index] ? (
                      <>
                        <IoClose
                          style={{ color: 'red', marginRight: '10px' }}
                        />
                        <span
                          style={{
                            direction: locale === 'ar' ? 'rtl' : 'ltr',
                            color: Colors.primaryText,
                          }}
                        >
                          {incorrectExamples[index]}
                        </span>
                      </>
                    ) : (
                      <span>&nbsp;</span> // Empty space for alignment
                    )}
                  </div>
                )}
                {/* Correct Examples Column */}
                {correctExamples.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '30%',
                    }}
                  >
                    {correctExamples[index] ? (
                      <>
                        <FaCheck
                          style={{ color: 'green', marginRight: '10px' }}
                        />
                        <span
                          style={{
                            direction: locale === 'ar' ? 'rtl' : 'ltr',
                            color: Colors.primaryText,
                          }}
                        >
                          {correctExamples[index]}
                        </span>
                      </>
                    ) : (
                      <span>&nbsp;</span> // Empty space for alignment
                    )}
                  </div>
                )}
              </Row>
            ))}
          </div>
          <span
            style={{
              color: Colors.grey,
            }}
          >
            Please note: Not following those guidlines will result in rejecting
            your request.
          </span>
        </div>
      </AccordionItem>
    </Accordion>
  );
};
